export default __webpack_public_path__ + "static/media/javamap-dark.05085369.png";